<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <h4 class="text-primary font-weight-bold mb-5">متن‌های از پیش آماده</h4>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <ckeditor v-model="form.body" ref="ticketTemplatesTextEditor"/>
                <div class="d-flex align-center cursor-pointer bg-blue-grey-lighten-5 pa-3 border border-t-0" @click="ticketTemplatesTabsShow = !ticketTemplatesTabsShow">
                    <p class="text-secondary text-small font-weight-bold user-select-none">
                        <v-icon color="secondary" size="18" class="me-2">icon-parameter</v-icon>پارامتر های داینامیک
                    </p>
                    <v-icon class="cursor-pointer me-2" color="secondary" size="18" v-tooltip="'پارامترهای داینامیک عباراتی هستند که پس از ثبت یا پاسخ به تیکت‌ها با مقادیر ذخیره شده در بانک اطلاعاتی جایگزین خواهند گردید. علائم [[ و ]] جزو بدنه پارامترها بوده و نباید حذف گردند.'">info</v-icon>
                    <v-spacer></v-spacer>
                    <v-icon color="grey-darken-1" size="24">{{ ticketTemplatesTabsShow ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
                </div>
                <v-expand-transition>
                    <div v-show="ticketTemplatesTabsShow">
                        <div class="d-flex border border-t-0">
                            <v-tabs color="secondary" :items="Object.keys(ticketTemplatesTabs)" direction="vertical">
                                <template v-slot:tab="{ item }">
                                    <v-tab class="border-e-md" :value="item.text">{{ ticketTemplatesTabs[item.text].name }}</v-tab>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-tabs-window-item :value="item.text">
                                        <v-chip-group column class="pa-2">
                                            <v-chip @click="addTemplate(item.data)" v-for="item in ticketTemplatesTabs[item.text].children">{{ item.name }}</v-chip>
                                        </v-chip-group>
                                    </v-tabs-window-item>
                                </template>
                            </v-tabs>
                        </div>
                    </div>
                </v-expand-transition>
                <v-select
                    :rules="$validation('required')"
                    :items="departmentList"
                    v-model="form.department_id"
                    label="* دپارتمان مرتبط"
                    no-data-text="موردی پیدا نشد!"
                    class="mt-7"
                    item-title="name"
                    item-value="id"
                ></v-select>
                <v-btn color="success" type="submit" class="mt-3" :loading="loading">ثبت اطلاعات</v-btn>
            </v-form>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "ایجاد",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.ticket_canned_message;
    },
    data() {
        return {
            loading: false,
            ticketTemplatesTabsShow: false,
            departmentList: [],
            form: { name: null, body: '', department_id: null },
            ticketTemplatesTabs: {
                system: {
                    name: "سازمانی",
                    children: [
                        { name: "وبسایت شعبه", data: "[[branch_website]]" },
                        { name: "ایمیل شعبه", data: "[[branch_email]]" },
                        {
                            name: "شماره تماس شعبه",
                            data: "[[branch_landline]]",
                        },
                    ],
                },
                ticket: {
                    name: "تیکت",
                    children: [
                        { name: "شماره تیکت", data: "[[identifier]]" },
                        { name: "موضوع تیکت", data: "[[subject]]" },
                        { name: "تاریخ ایجاد تیکت", data: "[[create_date]]" },
                        {
                            name: "تاریخ آخرین بروزرسانی تیکت",
                            data: "[[last_update_date]]",
                        },
                        { name: "میزان اهمیت تیکت", data: "[[priority]]" },
                        {
                            name: "عنوان دسته بندی تیکت",
                            data: "[[category_title]]",
                        },
                    ],
                },
                writer: {
                    name: "نویسنده",
                    children: [
                        { name: "نام", data: "[[writer_first_name]]" },
                        { name: "نام خانوادگی", data: "[[writer_last_name]]" },
                    ],
                },
            },
        };
    },
    methods: {
        addTemplate(item) {
            this.$refs.ticketTemplatesTextEditor.insertContent(item)
        },
        submit() {
            if(!this.form.body.replace(/<[^>]*>?/gm, ""))
                this.$toast.error('متن اجباری می‌باشد.')
            else {
                this.loading = true;
                this.$ticketTemplateStore(this.form).then((res) => {
                    if (res && res.status == "CREATED") {
                        this.$toast.success(res.message);
                        this.$system.setSystemDefaults(true);
                        this.$router.push({path: '/settings/ticketTemplates' });
                    }
                }).finally(()=>{this.loading = false});
            }
        },
    },
    mounted() {
        this.departmentList = this.$system.departments;
    },
};
</script>
